module.exports = __webpack_public_path__ + "static/media/onlinepayment.722e1b15.svg";